<div class="container">
  <div class="row my-5 py-5">
    <multisite-content-list-formats-duplicate [contentItems]="surveysAsContent" [imageTransformations]="'w_700,c_fill,ar_16:9/'"
      (itemSelected)="gotoSurvey($event)">
    </multisite-content-list-formats-duplicate>
    <multisite-loader-globe-animation-detail *ngIf="loading" width="100" height="100" class="my-3"></multisite-loader-globe-animation-detail>
  </div>
</div>